/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React, { Component } from 'react'
import { Dropdown, Form, Button, Icon, Popup } from 'semantic-ui-react'
import _ from 'lodash'

export class DropDown extends Component {
  constructor() {
    super()
    this.state = {}
  }
  errorPopup = error => {
    return (
      <Popup trigger={<Icon name='warning sign info' color='red' />} content={error || ''} />
    )
  }
  getDropDownText = (option) => {
    let displayText = option;
    if (option.stringVal) { // If there is a stringVal, use that
      displayText = option.stringVal
    } else {
      if (option.value && option.text && option.description) { 
        displayText =  option.text;
      }else if (option.value && option.text) { 
        displayText = option.text + ' - ' + option.value
      }else if (option.text) { 
        displayText =  option.text
      }
    }
    if(typeof displayText === 'string'){
      return displayText.replace(/_/g, " ");
    }
    return displayText;
  }

  getDropDownText2 = (option) => {
    let displayText = option;
    if (option.stringVal) { // If there is a stringVal, use that
      displayText = option.stringVal
    } else {
      if (option.value && option.text && option.description) { 
        displayText =  option.text;
      }else if (option.value && option.text) { 
        displayText = option.value + ' - ' + option.text
      }else if (option.text) { 
        displayText =  option.text
      }
    }
    if(typeof displayText === 'string'){
      return displayText.replace(/_/g, " ");
    }
    return displayText;
  }

  getDropDownValue = (option) => {
    if (option.stringVal) { // If there is a stringVal, use that
      return option.stringVal
    } else {
      // If not stringVal, it is likely a Master
      if (option.id) { // If master (ie there is an id), return the id
        return option.value
      }
    }
    // If no matches were found
    return option
  }

  handleChange = (e, { value }) => {
    this.props.onChange(value)
    document.getElementsByClassName('active-label')[0] &&
                document
                  .getElementsByClassName('active-label')[0]
                  .classList.remove('active-label')
    // this.props.onChange(
    //   this.props.data && this.props.data.find(obj => obj.description === value)
    //     ? this.props.data.find(obj => obj.description === value).id
    //     : value
    // )
  }
  render() {
    const {
      label,
      className,
      columnClassName,
      width,
      data,
      disabled = false,
      direction,
      labelClassName,
      centerSelect,
      onChange,
      text,
      onBlur,
      id,
      onButtonClick,
      button,
      handleFocus,
      labelIcon,
      setINPUTID,
      shipmentId,
      penClicked,
      error,
      multiple,
      placeholder
    } = this.props
    
    let drop_data = data === undefined ? [] : data;
    let dpText = this.getDropDownText2;
    let options = _.map(drop_data, (item, index) => ({
      key: index,
      text: dpText(item),
      value: this.getDropDownValue(item),
      description: item.description
    }))

    return (
      <React.Fragment>
        <Form.Field
          width={width}
          className={`floating-select ${centerSelect &&
            'floating-select-center'} ${columnClassName || ''}`}
        >
          {label && (
            <label
              id={`${id}label`}
              htmlFor='floatField'
              className={'label-dropdown name-label es ' + labelClassName || ''}
            >
              {error && this.errorPopup(error)}
              {label}
              {labelIcon && labelIcon}
            </label>
          )}
          <Dropdown
            closeOnChange
            selectOnBlur={false}
            scrolling
            search
            multiple={multiple}
            selection
            options={options}
            placeholder={placeholder}
            onChange={onChange && this.handleChange}
            title={text}
            text={text}
            id={id}
            name={id}
            direction={direction}
            disabled={disabled}
            small='true'
            className={className}
            onBlur={() => {
              onBlur && onBlur()
            }}
            onFocus={event => {
              handleFocus && handleFocus(event)
              // setINPUTID && setINPUTID(id + shipmentId)
            }}
            onMouseDown={e => {
              e.stopPropagation()
              // penClicked && penClicked(e)
            }}
          />
          {/* {button && (
            <Button
              basic
              color='blue'
              className='openButton'
              onClick={e => onButtonClick(e)}
            >
              {button}
            </Button>
          )} */}
        </Form.Field>
      </React.Fragment>
    )
  }
}

export default DropDown
